import { FormattedMessage, defineMessage } from 'react-intl'
import { Wrapper } from 'routes/ThankYou/styles'
import Text from 'components/shared/Text'
import ImageInfoBox from 'components/shared/ImageInfoBox'
import * as LINKS from 'constants/links'
import { useApp } from 'store/steps'
import { useResolutions } from 'store/resolutions'
import attractionsPhoto from 'assets/images/thankYou/attractionsPhoto.png'
import attractionsPhotoMobile from 'assets/images/thankYou/attractionsPhoto_mobile.png'

export const ThankYouAttractions = () => {
    const { language } = useApp()
    const { isTablet } = useResolutions()

    return (
        <Wrapper
            gap={24}
            align={['center', 'flex-start']}
            justify="space-between"
            isFullWidth
            isLongTitle={language === 'en'}
        >
            <Text
                variant="heading2"
                color="grayscale_900"
                align={['center', 'left']}
            >
                <FormattedMessage
                    id="order.thankyou.attractions"
                    defaultMessage="Zobacz <span>udogodnienia i atrakcje</span>"
                    description="Keep the html tags in the translation"
                    values={{
                        span: (chunks: string[]) => (
                            <>
                                <Text
                                    as="span"
                                    variant="heading2"
                                    color="primary_500"
                                >
                                    {chunks}
                                </Text>
                            </>
                        ),
                    }}
                />
            </Text>
            <ImageInfoBox
                image={isTablet ? attractionsPhotoMobile : attractionsPhoto}
                imageAlt="restaurants"
                title={defineMessage({
                    id: 'order.thankyou.attractions_title_subheading',
                    defaultMessage: 'Udogodnienia i atrakcje',
                })}
                desc={defineMessage({
                    id: 'order.thankyou.attractions_title_message',
                    defaultMessage:
                        'Komfortowa cabana, symulator surfowania, a może relaksujący zabieg w strefie SPA? Wybierz to, czego potrzebujesz!',
                })}
                linkText={defineMessage({
                    id: 'annual.btn.attractions',
                    defaultMessage: 'Zobacz udogodnienia i atrakcje',
                })}
                linkUrl={LINKS.ATTRACTIONS_LINK}
            />
        </Wrapper>
    )
}
